import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ContactBlock } from "./ContactBlock";

export const contactBlocks: BlockExportMapping = {
  ContactBlock1: ContactBlock,
};
